import { render, staticRenderFns } from "./TableMaterialOffered.vue?vue&type=template&id=7154c514"
import script from "./TableMaterialOffered.vue?vue&type=script&lang=js"
export * from "./TableMaterialOffered.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports